import paths from "./paths";

// export const appRoutes = {
//   label: 'Dashboard',
//   labelDisable: true,
//   children: [
//     {
//       name: 'Dashboard',
//       active: true,
//       icon: 'chart-pie',
//       to: rootPaths.root,
//       exact: true,
//     }
//   ]
// };

export const osirisDashboardRoutes = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      active: true,
      icon: "project-diagram",
      to: paths.osirisDashboard,
    },
  ],
};

export const osirisDatasetRoutes = {
  label: "Dataset",
  children: [
    {
      name: "Add",
      active: true,
      icon: "file-upload",
      to: paths.osirisDatasetAdd,
    },
    // Temporary for dev, TODO DELETE Matisse
    // {
    //   name: "Temporary",
    //   active: true,
    //   icon: "project-diagram",
    //   to: paths + "/temporary/AddDataset",
    // },
  ],
};

export const osirisComputationRoutes = {
  label: "Computation",
  children: [
    {
      name: "Add",
      icon: "file-upload",
      to: paths.osirisComputationAdd,
      active: true,
    },
    {
      name: "Charts & KPIs",
      icon: "chart-line",
      to: paths.osirisComputationCharts,
      active: true,
    },
    {
      name: "Analysis",
      icon: "chart-pie",
      to: paths.osirisComputationAnalysis,
      active: true,
    },
    {
      name: "Result",
      icon: "table",
      to: paths.osirisComputationResult,
      active: true,
    },
  ],
};

export const osirisControlRoutes = {
  label: "Control",
  children: [
    {
      name: "Charts & KPIs",
      icon: "chart-line",
      to: paths.osirisControlCharts,
      active: true,
    },
    {
      name: "Analysis",
      icon: "chart-pie",
      to: paths.osirisControlAnalysis,
      active: true,
    },
    {
      name: "Result",
      icon: "table",
      to: paths.osirisControlResult,
      active: true,
    },
  ],
};

export const osirisVariationAnalysisRoutes = {
  label: "Variation Analysis",
  children: [
    {
      name: "Add",
      icon: "file-upload",
      to: paths.osirisVariationAnalysisAdd,
      active: true,
    },
    {
      name: "Charts & KPIs",
      icon: "chart-line",
      to: paths.osirisVariationAnalysisCharts,
      active: true,
    },
    {
      name: "Analysis",
      icon: "chart-pie",
      to: paths.osirisVariationAnalysisAnalysis,
      active: true,
    },
    {
      name: "Result",
      icon: "table",
      to: paths.osirisVariationAnalysisResult,
      active: true,
    },
  ],
};

export default [
  osirisDashboardRoutes,
  osirisDatasetRoutes,
  osirisComputationRoutes,
  osirisControlRoutes,
  osirisVariationAnalysisRoutes,
];
